import { render, staticRenderFns } from "./HeatMap2.vue?vue&type=template&id=0de54d39&scoped=true&"
import script from "./HeatMap2.vue?vue&type=script&lang=ts&"
export * from "./HeatMap2.vue?vue&type=script&lang=ts&"
import style0 from "./HeatMap2.vue?vue&type=style&index=0&id=0de54d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de54d39",
  null
  
)

export default component.exports